module.exports = __webpack_public_path__ + "static/logo-blanco-21f918bba43f4d4a581c7eb92058ed54.png";